// export const BASE_URL = "http://localhost:3001/api";
// export const CDN_BASE_URL = "http://localhost:3001/";

export const BASE_URL = "https://api.drgoldco.ir/api";
export const CDN_BASE_URL = "https://api.drgoldco.ir/";

// export const CDN_BASE_URL = "http://localhost:3001/";
// export const BASE_URL = "http://localhost:3001/api";
